import { graphql } from "api/cms-website/generated";

export const InfoBannerFragment = graphql(/* GraphQL */ `
    fragment InfoBannerFragment on ComponentComponentsInfoBanner {
        id
        noMarginBottom
        infoBannerTitle: title
        infoBannerText: text
        bg {
            type
        }
        iconColor {
            type
        }
        titleColor {
            type
        }
        icon {
            ...IconFragment
        }
        infoBannerItems: items {
            text
            icon {
                ...IconFragment
            }
        }
        infoBannerCta: cta {
            ...ButtonFragment
        }
    }
`);
